import { LiveAgentInteractionCardRenderer, LiveAgentTransferCardRenderer } from '@bingads-webui/copilot-live-agent';

export const renderers = [
  LiveAgentInteractionCardRenderer,
  LiveAgentTransferCardRenderer,
];
